import React, { memo, ReactNode } from 'react';

import ViewMore from '@/3.0/home/_components/view-more';
import { ViralTemplateExposeFromEnum } from '@/utils/eventlog/eventNewConfig';

import type { TplTemplateVO } from '../../../template-ui/types';
import TemplateGrid from '../TemplateGrid';

const CARD_W = 180;
const GAP = 15;

function CategorySectionShell({
  header,
  tabs,
  gridAnchorRef,
  items,
  loading,
  from,
  columns,
  showViewMore,
  onViewMore,
  onReplicate,
}: {
  header: ReactNode;
  tabs?: ReactNode;
  gridAnchorRef: React.RefObject<HTMLDivElement>;
  items: TplTemplateVO[];
  loading: boolean;
  from: ViralTemplateExposeFromEnum;
  columns: number;
  /** 仅当大类条数超过当前宽度下的两行容量时展示 */
  showViewMore: boolean;
  onViewMore: () => void;
  /** 点击卡片上「复刻」按钮：拉表单详情并弹窗 */
  onReplicate?: (tpl: TplTemplateVO) => void;
}) {
  return (
    <div className="flex flex-col gap-[10px] w-full pb-[24px]">
      {header}
      {tabs}

      <div ref={gridAnchorRef} className="w-full">
        <TemplateGrid
          items={items}
          loading={loading}
          from={from}
          columns={columns}
          cardWidth={CARD_W}
          gap={GAP}
          rowHeight={320}
          onReplicate={onReplicate}
        />
      </div>

      {showViewMore && items.length > 0 && (
        <div className="flex justify-center pt-[6px] py-[24px]">
          <ViewMore behavior="action" onExpand={onViewMore} />
        </div>
      )}
    </div>
  );
}

export default memo(CategorySectionShell);
